import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
  },
  input: {
    backgroundColor: theme.palette.common.paleGrey,
    paddingLeft:10,
  },
  inputWithPrefix: {
    paddingLeft: 0,
  },
  adornment: {
    height: 'auto',
    maxHeight: 'none',
    alignSelf: 'stretch',
    margin: 0,
    marginRight: '0.75rem',
    padding: '0 0.75rem',
    display: 'flex',
    alignItems: 'center',
    borderRight: `1px solid ${theme.palette.grey[400]}`,
  },
  code: {
    marginLeft: '0.4rem',
    color: theme.palette.text.primary,
  },
}));

const MobileField = ({ value, onChange, onEnter, onFocus, onBlur, error, ...props }) => {
  const classes = useStyles();
  const [focused, setFocused] = useState(false);
  const showPrefix = focused || !!value;

  const onKeyUp = (event) => {
    if (event.keyCode === 13 && onEnter) {
      onEnter();
    }
  };

  const handleFocus = (event) => {
    setFocused(true);
    if (onFocus) onFocus(event);
  };

  const handleBlur = (event) => {
    setFocused(false);
    if (onBlur) onBlur(event);
  };

  return (
    <FormControl className={classes.formControl}>
      <TextField
        fullWidth
        variant="outlined"
        type="tel"
        autoComplete="tel-national"
        placeholder="400 000 000"
        value={value}
        error={error !== undefined}
        onChange={event => onChange && onChange(event.target.value)}
        onKeyUp={onEnter ? onKeyUp : undefined}
        onFocus={handleFocus}
        onBlur={handleBlur}
        InputProps={{
          className: showPrefix
            ? `${classes.input} ${classes.inputWithPrefix}`
            : classes.input,
          startAdornment: showPrefix ? (
            <InputAdornment position="start" className={classes.adornment}>
              <span role="img" aria-label="Australia">🇦🇺</span>
              <span className={classes.code}>+61</span>
            </InputAdornment>
          ) : null,
        }}
        {...props}
      />
      {error && <Alert severity="error">{error}</Alert>}
    </FormControl>
  );
};

MobileField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
};

export default MobileField;
